export enum PaymentMethodsEnum {
    Cash = "cash",
    Card = "card",
    Delivery = "delivery",
    Transfer = "transfer",
}